var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
  fill: "#F1F7FA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0387 15.7054L15.4613 12.128C15.2985 11.9653 15.0347 11.9653 14.872 12.128L14.2859 12.7142C14.1233 12.8767 14.1231 13.1402 14.2854 13.303L16.975 16.0001L14.2854 18.6971C14.1231 18.8599 14.1233 19.1234 14.2859 19.2859L14.872 19.8721C15.0347 20.0348 15.2985 20.0348 15.4613 19.8721L19.0387 16.2947C19.2014 16.132 19.2014 15.8681 19.0387 15.7054Z",
  fill: "#8291A4"
})));
export default SvgCalendarArrowRight;